/** Initial independent d6 roll only; optional reactions and rerolls are excluded. */
export function checkProbability(dice: number, required: number, threshold: number): number {
  const n = Math.max(0, Math.floor(dice));
  const k = Math.max(0, Math.ceil(required));
  if (k === 0) return 1;
  if (k > n) return 0;
  const p = Math.max(0, Math.min(1, (7 - threshold) / 6));
  if (p === 0) return 0;
  if (p === 1) return 1;
  // Sum in log space to keep tiny, possible chances distinct from impossible checks.
  const lower = k <= n * p;
  const start = lower ? 0 : k;
  const end = lower ? k - 1 : n;
  let logChoose = 0;
  for (let j = 1; j <= Math.min(start, n - start); j++) logChoose += Math.log(n - j + 1) - Math.log(j);
  let term = logChoose + start * Math.log(p) + (n - start) * Math.log1p(-p);
  let sum = -Infinity;
  for (let j = start; j <= end; j++) {
    const max = Math.max(sum, term);
    sum = max + Math.log(Math.exp(sum - max) + Math.exp(term - max));
    term += Math.log(n - j) - Math.log(j + 1) + Math.log(p) - Math.log1p(-p);
  }
  const result = lower ? -Math.expm1(sum) : Math.exp(sum);
  return Math.min(1 - Number.EPSILON, Math.max(Number.MIN_VALUE, result));
}

export function formatCheckProbability(chance: number): string {
  if (chance === 0) return '0%';
  if (chance === 1) return '100%';
  if (chance < .01) return '<1%';
  if (chance > .99) return '>99%';
  return `~${Math.round(chance * 100)}%`;
}
